import smartSolveApi from './instances/smartsolve';

export const initiateEntityImport = async (file, link, { entityName }) => {
  const formData = new FormData();

  formData.append('FileName', file.name);
  formData.append('FileDescription', '');
  formData.append('FileStream', file);
  formData.append('Link', link);
  formData.append('EntityName', entityName);

  try {
    const response = await smartSolveApi.post('/InitiateEntityImport', formData);

    return response.data;
  } catch (e) {
    throw new Error(`initiateEntityImport() failed: ${e}`);
  }
};

export const importEntity = async ({ importKey }) => {
  try {
    const response = await smartSolveApi.post('/ImportEntity', { importKey });

    return response.data;
  } catch (e) {
    throw new Error(`importEntity() failed: ${e}`);
  }
};

export const entityImportStatus = async ({ importKey }) => {
  try {
    const response = await smartSolveApi.post('/ImportEntityStatus', { importKey });

    return response.data;
  } catch (e) {
    throw new Error(`importEntityStatus() failed: ${e}`);
  }
};

export const downloadEntityImportTemplate = async (params) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/downloadentityimporttemplate',
      { ...params },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (e) {
    throw new Error(`downloadEntityImportTemplate() failed: ${e}`);
  }
};

export const downloadEntityImportResult = async ({ importKey }) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/downloadentityimportresult',
      { importKey },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (e) {
    throw new Error(`downloadEntityImportResult() failed: ${e}`);
  }
};

export const downloadEntityImportedFile = async ({ importKey }) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/downloadentityimportedfile',
      { importKey },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (e) {
    throw new Error(`downloadEntityImportedFile() failed: ${e}`);
  }
};

export const entityImportHistory = async ({ importEntityKey }) => {
  try {
    const response = await smartSolveApi.post('/entityimportHistory', {
      ImportEntityKey: importEntityKey,
    });

    return response.data;
  } catch (e) {
    throw new Error(`entityImportHistory() failed: ${e}`);
  }
};

export const getBulkImportActions = async (entityKey) => {
  try {
    const response = await smartSolveApi.post('/bulkimportactions', {
      entityKey,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getBulkImportActions() failed: ${e}`);
  }
};
